/*
  Branded loading screen controller.

  Two jobs:
  1. Opening screen — the inline script in pujalane-splash.liquid reveals it
     during parse (once per session); this hides it once the page is ready.
  2. Slow navigations — shown only if a page transition is still going after
     SLOW_MS, so quick pages never flash it.

  A CSS failsafe hides the overlay after 8s regardless, so a script error can
  never leave a shopper staring at a stuck screen.
*/
(function () {
  var splash = document.querySelector('[data-pl-splash]');
  if (!splash) return;

  var MIN_MS = 900; // don't flash the intro away instantly
  var SLOW_MS = 400; // only show on navigations that actually feel slow
  var shownAt = Date.now();
  var slowTimer = null;

  function show() {
    shownAt = Date.now();
    splash.removeAttribute('hidden');
    // Force a reflow so the entry animation restarts on repeat shows.
    void splash.offsetWidth;
    splash.setAttribute('data-pl-splash-on', '');
  }

  function hide(respectMinimum) {
    var elapsed = Date.now() - shownAt;
    var wait = respectMinimum && elapsed < MIN_MS ? MIN_MS - elapsed : 0;

    setTimeout(function () {
      splash.removeAttribute('data-pl-splash-on');
      splash.setAttribute('data-pl-splash-out', '');
      setTimeout(function () {
        splash.setAttribute('hidden', '');
        splash.removeAttribute('data-pl-splash-out');
        splash.removeAttribute('data-pl-splash-intro');
      }, 320); // matches the fade-out duration in CSS
    }, wait);
  }

  /* ---------- opening screen ---------- */

  /* Hides on DOMContentLoaded, not window.load. `load` waits for every
     subresource on the page — including the third-party app scripts — so it
     kept the overlay up long after the store itself was usable and ready. */
  if (splash.hasAttribute('data-pl-splash-intro')) {
    splash.setAttribute('data-pl-splash-on', '');
    if (document.readyState !== 'loading') hide(true);
    else
      document.addEventListener('DOMContentLoaded', function () {
        hide(true);
      });
  }

  /* ---------- slow navigations ---------- */

  function armFor(url) {
    clearTimeout(slowTimer);
    slowTimer = setTimeout(show, SLOW_MS);
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;

      // Ignore anything that will not actually navigate this tab.
      if (link.target && link.target !== '_self') return;
      if (link.hasAttribute('download')) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

      var href = link.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#') return;
      if (/^(mailto:|tel:|javascript:)/i.test(href)) return;
      if (link.hostname && link.hostname !== window.location.hostname) return;

      // Same page, different hash only.
      if (link.pathname === window.location.pathname && link.search === window.location.search) {
        return;
      }

      armFor(href);
    },
    true
  );

  // Full form submissions navigate too (search, login, checkout).
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.getAttribute('data-pl-no-splash') !== null) return;
      // Dawn's AJAX forms handle themselves and never leave the page.
      if (form.closest('product-form, cart-drawer, quick-add-modal')) return;
      armFor('');
    },
    true
  );

  // The browser is actually leaving — keep it visible through the handover.
  window.addEventListener('beforeunload', function () {
    clearTimeout(slowTimer);
    show();
  });

  // Restored from bfcache: the old page is back, so nothing is loading.
  window.addEventListener('pageshow', function (event) {
    clearTimeout(slowTimer);
    if (event.persisted) hide(false);
  });

  // Navigation cancelled (download, blocked, or the user hit stop).
  window.addEventListener('focus', function () {
    clearTimeout(slowTimer);
  });
})();
